var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_168_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3062 21.9485C11.3054 24.0586 11.8605 26.1184 12.9154 27.9341L11.205 34.1379L17.5963 32.4732C19.3573 33.4272 21.3399 33.9299 23.3576 33.9307H23.3628C30.0074 33.9307 35.4164 28.5591 35.4192 21.9582C35.4203 18.7589 34.1674 15.7508 31.8912 13.4878C29.6147 11.2249 26.5877 9.97805 23.3628 9.97664C16.7171 9.97664 11.3089 15.3473 11.3062 21.9485Z",
    fill: "black",
    fillOpacity: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7389 21.8236C11.7383 23.8531 12.2735 25.8348 13.2913 27.5814L11.6415 33.5496L17.8061 31.9481C19.5045 32.8652 21.4168 33.3492 23.3629 33.3499H23.3681C29.7769 33.3499 34.9938 28.183 34.9965 21.8326C34.9978 18.7553 33.7892 15.8617 31.5935 13.6848C29.3982 11.5079 26.4785 10.3084 23.3677 10.307C16.9581 10.307 11.7415 15.4734 11.7389 21.8236Z",
    fill: "url(#paint0_linear_168_46)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3237 21.8196C11.3229 23.9223 11.8774 25.9749 12.9315 27.7841L11.2225 33.9661L17.6083 32.3072C19.3677 33.2578 21.3485 33.7588 23.3645 33.7595H23.3697C30.0085 33.7595 35.4127 28.4069 35.4155 21.8293C35.4166 18.6413 34.1648 15.6439 31.8906 13.3888C29.6162 11.1339 26.5918 9.89149 23.3697 9.89003C16.7298 9.89003 11.3263 15.2417 11.3236 21.8196H11.3237ZM15.1264 27.4726L14.8881 27.0975C13.8858 25.5187 13.3567 23.694 13.3575 21.8204C13.3597 16.3531 17.8508 11.9051 23.3735 11.9051C26.0479 11.9062 28.5614 12.9389 30.4519 14.8132C32.3422 16.6873 33.3824 19.1788 33.3816 21.8285C33.3793 27.296 28.888 31.7446 23.3697 31.7446H23.3658C21.5689 31.7437 19.8068 31.2657 18.2699 30.3622L17.9041 30.1474L14.1147 31.1317L15.1264 27.4726Z",
    fill: "url(#paint1_linear_168_46)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.359 16.8325C20.1335 16.336 19.8962 16.326 19.6817 16.3173C19.5063 16.3098 19.3054 16.3103 19.1049 16.3103C18.9042 16.3103 18.5781 16.385 18.3024 16.6834C18.0264 16.9818 17.2488 17.7031 17.2488 19.1702C17.2488 20.6375 18.3274 22.055 18.4778 22.2542C18.6283 22.453 20.56 25.5598 23.6193 26.7551C26.1618 27.7484 26.6792 27.5509 27.2311 27.5012C27.7829 27.4515 29.0118 26.78 29.2626 26.0837C29.5135 25.3874 29.5135 24.7907 29.4382 24.666C29.363 24.5417 29.1623 24.4671 28.8613 24.318C28.5602 24.1689 27.0805 23.4474 26.8046 23.348C26.5287 23.2486 26.328 23.1989 26.1273 23.4974C25.9266 23.7957 25.3502 24.4671 25.1745 24.666C24.999 24.8653 24.8234 24.8901 24.5223 24.741C24.2213 24.5914 23.2519 24.2768 22.102 23.261C21.2072 22.4707 20.6032 21.4946 20.4275 21.1961C20.2519 20.8979 20.4087 20.7363 20.5597 20.5877C20.6948 20.4541 20.8608 20.2396 21.0112 20.0655C21.1614 19.8914 21.2116 19.7671 21.3119 19.5683C21.4123 19.3691 21.3621 19.195 21.2869 19.0459C21.2116 18.8968 20.6267 17.4221 20.359 16.8325Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_168_46",
    x: 7.79126,
    y: 6.56285,
    width: 31.0417,
    height: 30.9888,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.70686,
    result: "effect1_foregroundBlur_168_46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_168_46",
    x1: 23.3189,
    y1: 33.5496,
    x2: 23.3189,
    y2: 10.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_168_46",
    x1: 23.3191,
    y1: 33.9661,
    x2: 23.3191,
    y2: 9.89004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.b507de3c511f6084696cb21ecc1528f6.svg";
export { ForwardRef as ReactComponent };